import { observable } from "mobx";
import { Type } from "class-transformer";
import VehicleRegisterVehicleCategory from "./vehicleRegisterVehicleCategory";
import VehicleRegisterVehicleClassifiedFuelType from "./vehicleRegisterVehicleClassifiedFuelType";
import type VehicleRegisterVehicleFuelType from "./vehicleRegisterVehicleFuelType";
import VehicleRegisterVehicleStatus from "./vehicleRegisterVehicleStatus";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class VehicleRegisterVehicleChange {
  /**
   * Vehicle serial number - unique vehicle identifier in the vehicle register.
   */
  @observable
  externalVehicleIdent!: number;

  /**
   * License plate.
   */
  @observable
  licensePlate!: string;

  /**
   * VIN (vehicle identification number) - an internationally unique identifier for motor vehicles.
   */
  @observable
  vin?: string;

  /**
   * Date on which the vehicle has been assigned its license plate.
   */
  @observable
  @Type(() => Date)
  licensePlateValidSinceDate?: Date;

  /**
   * Date until which the vehicle has been assigned its license plate.
   */
  @observable
  @Type(() => Date)
  licensePlateValidUntilDate?: Date;

  @observable
  vehicleStatus?: VehicleRegisterVehicleStatus;

  /**
   * Date from which the vehicle has the specified status.
   */
  @observable
  @Type(() => Date)
  vehicleStatusValidSinceDate?: Date;

  /**
   * Date until which the vehicle has the specified status.
   */
  @observable
  @Type(() => Date)
  vehicleStatusValidUntilDate?: Date;

  @observable
  category?: VehicleRegisterVehicleCategory;

  /**
   * Full name of the vehicle category.
   */
  @observable
  categoryName?: string;

  /**
   * Maximum allowed weight.
   */
  @observable
  maximumAllowedWeight?: number;

  /**
   * Co2 emissions.
   */
  @observable
  emissionsCo2?: number;

  /**
   * Fuel types.
   */
  @observable
  fuelTypes?: VehicleRegisterVehicleFuelType[];

  /**
   * Full name of fuel type 1.
   */
  @observable
  fuelTypeName1?: string;

  /**
   * Full name of fuel type 2.
   */
  @observable
  fuelTypeName2?: string;

  /**
   * Full name of fuel type 3.
   */
  @observable
  fuelTypeName3?: string;

  @observable
  classifiedFuelType?: VehicleRegisterVehicleClassifiedFuelType;
}
